import React, { useContext } from 'react';
import { Sheet } from 'react-modal-sheet';
import cardContext from '../../context/cards/cardContext';
import './CartBottomSheet.css';

const CartBottomSheet = ({ isOpen, onClose }) => {
    const { getCartItems, handleQuantityChange } = useContext(cardContext);
    const cartItems = getCartItems();

    return (
        <Sheet isOpen={isOpen} onClose={onClose} disableScrollLocking = {true} detent='content'>
            <Sheet.Container>
                <Sheet.Header>
                    <div className="bs-sheet-header">
                        <h2>Your Cart</h2>
                        <button className="bs-close-btn" onClick={onClose}>
                            ×
                        </button>
                    </div>
                </Sheet.Header>
                <Sheet.Content>
                    <div className="bs-cart-content">
                        {cartItems.length === 0 ? (
                            <div className="bs-empty-cart">
                                <p>Your cart is empty</p>
                            </div>
                        ) : (
                            <>
                                <div className="bs-cart-items">
                                    {cartItems.map((item) => (
                                        <div key={item.id} className="bs-cart-item">
                                            <img src={item.image} alt={item.name} className="bs-cart-item-image" />
                                            <div className="bs-cart-item-details">
                                                <h3>{item.name}</h3>
                                                <p className="bs-cart-item-price">₹{item.price}</p>
                                            </div>
                                            <div className="bs-cart-item-controls">
                                                <button 
                                                    className="bs-quantity-btn decrease"
                                                    onClick={() => handleQuantityChange(item.id, -1)}
                                                >
                                                    -
                                                </button>
                                                <span className="bs-quantity">{item.quantity}</span>
                                                <button 
                                                    className="bs-quantity-btn increase"
                                                    onClick={() => handleQuantityChange(item.id, 1)}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={onClose} />
        </Sheet>
    );
};

export default CartBottomSheet;
